import { render, staticRenderFns } from "./transaction_single.vue?vue&type=template&id=749218e2&"
import script from "./transaction_single.vue?vue&type=script&lang=js&"
export * from "./transaction_single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports